// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import { createRef } from 'react';

export const authContextRef = createRef();
